module.exports = __webpack_public_path__ + "img/lobby_hosting_xfz.f4c2c9c0.png";